import React, {StrictMode} from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import LoginApp from './LoginApp';
import "./index.css";

import { store } from './store';
import { Provider } from 'react-redux';

const root = createRoot(document.getElementById('root'));

root.render(
    <StrictMode>
        <Provider store={store}>
            <HashRouter>
                <LoginApp />
            </HashRouter>
        </Provider>
    </StrictMode>
);